import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

class CounterAnimation  {

    static instance = null;
    static create(options) {
        if (CounterAnimation.instance === null) {
            CounterAnimation.instance = new CounterAnimation(options);
        }
        return CounterAnimation.instance;
    }

    static get defaultOptions() {
        return {
            selector: null,
            delay: 0,
            speed:1
        };
    }

    constructor(options) {
        this.options = Object.assign({}, CounterAnimation.defaultOptions, options)
        this.setup();
    }

    setup() {
        [...this.options.selector].forEach((element) => {
            gsap.from(element, {
                textContent: "0",
                duration: this.options.speed,
                delay: this.options.delay,
                modifiers: {
                  textContent: value => this.formatNumber(value, 0)
                },
                scrollTrigger: {
                  trigger: element,
                  start: "top 80%",
                  end: "+=100",
                  toggleActions: "play none none reverse",
                  markers: false
                }
              });
        });
            
    }

    formatNumber(value, decimals) {
        let s = (+value).toLocaleString('en-US').split(".");
        return decimals ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals) : s[0];
      }

}

export default CounterAnimation;
